'use client';

import { c as _c } from "react/compiler-runtime";
import { BannerAdSlot } from '@/app/_components/ads';
import { AD_PLACEMENTS } from '@/app/_components/ads/adPlacements';
export const GiftDetailBannerAd = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <BannerAdSlot {...AD_PLACEMENTS.giftDetailBottom} wrapperClassName="flex justify-center p-20" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};